import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Valentine's day",
  "description": "",
  "published": "2007-02-14T00:00:00.000Z",
  "redirect_from": ["/blog/valentines-day/swizec/287"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`If you do not watch `}<a parentName="p" {...{
        "href": "http://www.zefrank.com/valentine/"
      }}>{`this amazing rant about Valentine's day`}</a>{` green monkeys will probably jump at you and eat your eyeballs out.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      